import TemplateStep4 from "Components/Templates/Step4";

export default function PageStep4() {
   console.log("step 4");
   return (
      <>
         <TemplateStep4></TemplateStep4>
      </>
   );
}
